import { defineAsyncComponent } from 'vue'
export default {
  "app-bar": defineAsyncComponent(() => import("/builds/eotlab/eotlab-website/layouts/AppBar.vue").then(m => m.default || m)),
  drawer: defineAsyncComponent(() => import("/builds/eotlab/eotlab-website/layouts/Drawer.vue").then(m => m.default || m)),
  footer: defineAsyncComponent(() => import("/builds/eotlab/eotlab-website/layouts/Footer.vue").then(m => m.default || m)),
  "system-bar": defineAsyncComponent(() => import("/builds/eotlab/eotlab-website/layouts/SystemBar.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/eotlab/eotlab-website/layouts/default.vue").then(m => m.default || m))
}